import { LayoutProps } from 'components/atoms/Layout/interfaces'
import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'

export const InputFormReset: {
    input: InputBuildProps
    layout: LayoutProps
}[] = [
    {
        input: {
            id: 'nomeUsuario',
            label: 'Usuário ou e-mail',
            maxLength: 128,
            required: true
        },
        layout: {
            type: 'col',
            layout: { base: 12 }
        }
    },
    {
        input: {
            id: 'senha',
            label: 'Senha',
            type: 'password',
            required: true,
            maxLength: 30
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        input: {
            id: 'senhaConfirmacao',
            label: 'Confirmação de senha',
            type: 'password',
            required: true,
            maxLength: 30
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    }
]
